import React from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import axios from 'axios';
import Spinner from '../../Spinner/Spinner';
import { Modal, ModalBody } from 'reactstrap';
import { resetIngredients } from '../../../../redux/actionCreators';


const mapStateToProps = state => {
    return {
        ingredients: state.ingredients,
        totalPrice: state.totalPrice,
        token: state.token,
        userId: state.userId,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        resetIngredients: () => dispatch(resetIngredients()),
    }
}

class Checkout extends React.Component {
    state = {
        isLoading: false,
        message: '',
        isModalOpen: false,
    }

    goBack = () => {
        this.props.history.goBack('/home')
    }
    //Done
    render() {
        document.title = 'Place Order'
        return (
            <div>
                {
                    this.state.isLoading ? <Spinner /> :

                        <div className='col-md-8 m-auto'
                        >
                            <Formik
                                initialValues={{
                                    deliveryAddress: '',
                                    phone: '',
                                    paymentType: 'Cash On Delivery'
                                }}
                                onSubmit={
                                    (values) => {
                                        this.setState({ isLoading: true });
                                        let order = {};
                                        order.customer = values;
                                        order.orderTime = new Date().toString();
                                        order.ingredients = this.props.ingredients;
                                        order.price = this.props.totalPrice;
                                        order.userId = this.props.userId;
                                        // axios post request
                                        axios.post('https://burger-builder-983fd-default-rtdb.firebaseio.com/orders.json?auth=' + this.props.token, order)
                                            .then(response => {
                                                if (response.status === 200) {
                                                    this.setState({ message: 'Order Placed Successfully!' })
                                                    this.props.resetIngredients();
                                                } else {
                                                    this.setState({ message: 'Something went wrong. Please try again..' })
                                                }
                                            })
                                            .catch(err => {
                                                this.setState({ message: `Order not placed for ${<span style={{ backgroundColor: 'black', color: 'white' }}>{err.message}</span>}` })
                                            })
                                            .finally(() => {
                                                this.setState({ isLoading: false, isModalOpen: true })
                                            })


                                    }
                                }
                                validate={
                                    (values) => {
                                        const errors = {};
                                        if (!values.deliveryAddress) {
                                            errors.deliveryAddress = '*Required'
                                        }

                                        if (!values.phone) {
                                            errors.phone = '*Required'
                                        } else if (!/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(values.phone)) errors.phone = 'Not a phone number'
                                        return errors;
                                    }
                                }
                            >
                                {
                                    ({ values, handleChange, handleSubmit, errors }) => (
                                        <div >
                                            <h4
                                                style={{
                                                    border: '1px solid grey',
                                                    borderRadius: '7px',
                                                    boxShadow: '1px #888888',
                                                    padding: '10px',
                                                    backgroundColor: '#D70F64',

                                                }}
                                            >Payment: {this.props.totalPrice}</h4>
                                            <form onSubmit={handleSubmit}
                                                style={{
                                                    border: '1px solid grey',
                                                    borderRadius: '7px',
                                                    boxShadow: '1px #888888',
                                                    padding: '20px',
                                                    backgroundColor: '#F1F3F4',

                                                }}
                                            >
                                                <textarea
                                                    name='deliveryAddress'
                                                    placeholder='Enter Your Delivery Address'
                                                    value={values.deliveryAddress}
                                                    onChange={handleChange}
                                                    className='form-control'
                                                    rows='5'
                                                />
                                                <span style={{ color: 'red' }}>{errors.deliveryAddress}</span><br />

                                                <input
                                                    name='phone'
                                                    placeholder='Phone Number'
                                                    value={values.phone}
                                                    onChange={handleChange}
                                                    className='form-control'
                                                />
                                                <span style={{ color: 'red' }}>{errors.phone}</span><br />

                                                <select type='select' name='paymentType' value={values.paymentType} className='form-control' onChange={handleChange}>
                                                    <option name='Cash On Delivery'>Cash On Delivery &raquo;</option>
                                                    <option name='bKash'>bKash</option>
                                                    <option name='DBBl'>DBBl</option>
                                                </select><br />
                                                <button type='submit' className='btn'
                                                    style={{
                                                        marginTop: '10px',
                                                        padding: '5px',
                                                        marginRight: '10px',
                                                        backgroundColor: '#D70F64',
                                                        textAlign: 'center',
                                                        width: '40%',
                                                        color: 'white'
                                                    }}
                                                    disabled={this.props.totalPrice <= 80}
                                                >Place Order</button>

                                                <button type='submit' className='btn btn-danger'
                                                    style={{
                                                        marginTop: '10px',
                                                        padding: '5px',
                                                        marginRight: '10px'
                                                    }}
                                                    onClick={this.goBack}
                                                >
                                                    Cancel</button>
                                            </form>
                                        </div>
                                    )
                                }
                            </Formik>
                        </div >
                }
                <Modal isOpen={this.state.isModalOpen} onClick={this.goBack}
                    style={{
                        marginTop: '20px',
                        padding: '40px',
                        boxShadow: '1px 1px grey',
                    }}
                >
                    <ModalBody><div>{this.state.message}</div></ModalBody>
                </Modal>

            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);